export const ARTICLE_1 = "ARTICLE_1";
export const ARTICLE_2 = "ARTICLE_2";
export const ARTICLE_3 = "ARTICLE_3";
export const ARTICLE_4 = "ARTICLE_4";
export const ARTICLE_5 = "ARTICLE_5";
export const ARTICLE_6 = "ARTICLE_6";
export const ARTICLE_7 = "ARTICLE_7";
export const ARTICLE_8 = "ARTICLE_8";
export const ARTICLE_9 = "ARTICLE_9";
export const ARTICLE_10 = "ARTICLE_10";
export const ARTICLE_11 = "ARTICLE_11";
export const ARTICLE_12 = "ARTICLE_12";
export const ARTICLE_13 = "ARTICLE_13";
export const ARTICLE_14 = "ARTICLE_14";
export const ARTICLE_15 = "ARTICLE_15";
export const ARTICLE_16 = "ARTICLE_16";
export const ARTICLE_17 = "ARTICLE_17";
export const ARTICLE_18 = "ARTICLE_18";

export default {
  ARTICLE_1,
  ARTICLE_2,
  ARTICLE_3,
  ARTICLE_4,
  ARTICLE_5,
  ARTICLE_6,
  ARTICLE_7,
  ARTICLE_8,
  ARTICLE_9,
  ARTICLE_10,
  ARTICLE_11,
  ARTICLE_12,
  ARTICLE_13,
  ARTICLE_14,
  ARTICLE_15,
  ARTICLE_16,
  ARTICLE_17,
  ARTICLE_18,
};
